import { initializeLogger } from '@b2x/shared';
import { buildTime, version } from './version';

const LOGGER_NAMESPACE = 'B2X@PL';

export const PL_LOG_GROUPS = {
  CORE: 'Core',
  INTEGRATIONS: 'Integrations',
  LEGACY: 'Legacy',
  STORE: 'Profiles Store',
} as const;

export const logger = initializeLogger<typeof PL_LOG_GROUPS>(LOGGER_NAMESPACE, { buildTime, version });
